import React from "react";
import { useController } from "react-hook-form";
import { DateSelector } from "@visa/vds";
import { FormHelper } from "_helpers/FormHelper";
import { DateHelper } from "_helpers/DateHelper";

function MCSControlCalendar(props) {
  const { field, fieldState } = useController(props);
  const handleChange = (e) => {
    if (!e) return
    field.onChange(DateHelper.ToUTCDateTime(e));
    props.handleChange(e);
  };

  const disableWeekendDates = date => {
    const day = date.getDay();
    return day === 6 || day === 0;
  };
  return (
    <DateSelector
      label={props.label}
      name={props.name}
      errorText={FormHelper.renderErrorMsg(fieldState.error)}
      showErrorText={fieldState.invalid}
      invalid={fieldState.invalid}
      value={field.value ? DateHelper.ToFormattedDate(field.value, "dd MMM yyyy") : ""}
      onSelect={handleChange}
      minDate={props.allowPastDates ? null : new Date()}
      maxDate={props.readOnly ? new Date(2100, 1, 1) : new Date(2011, 11, 11)}
      setDisabledDate={disableWeekendDates}
    />
  );
}

export default MCSControlCalendar;
